export default "__VITE_IMAGE_ASSET__868f46a5__";